<template>
  <transition name="fade-in" @after-enter="isOpen = true">
    <div v-if="isVisible" class="blind-box-popup-container">
      <div class="opaque-background" @click="isOpen = false"></div>
      <transition name="fade-in" @after-leave="$emit('close')">
        <div v-if="isOpen" style="z-index: 3">
          <slot></slot>
        </div>
      </transition>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isOpen: false,
    };
  },
};
</script>

<style lang="scss" scoped>
.fade-in-enter-active,
.fade-in-leave-active {
  transition: opacity 0.3s ease;
}
.fade-in-enter,
.fade-in-leave-to {
  opacity: 0;
}
.blind-box-popup-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
}
.opaque-background {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
}
</style>
